module.exports = __webpack_public_path__ + "img/4-4.454e7785.png";